import { IS_RUNTIME_FEDERATION } from "../src/constants/environment";
import { GeneralErrorPage } from "../src/pages/errors";
import { getGlobalStore } from "../src/utils/useGlobalStore";
import { logger } from "../src/utils/logger";
import { registry } from "../configs/registry";
import { loadRuntimeApplication } from "../src/federation/runtime";
import { getRemoteApplicationDynamically } from "../src/federation/build";
const getInitialApplication = async (id) => {
    try {
        const application = registry.getApplicationFromId(id);
        if (!application) {
            logger.error(`getApplicationFromId - no item found for application ${id}.`);
            return GeneralErrorPage;
        }
        if (IS_RUNTIME_FEDERATION) {
            return (await loadRuntimeApplication(application)).Component;
        }
        const { Component } = await getRemoteApplicationDynamically(id, application.urls.client);
        return Component;
    }
    catch {
        return GeneralErrorPage;
    }
};
const { initialApplication: initialApplicationInput } = getGlobalStore();
export const initialApplication = initialApplicationInput && {
    id: initialApplicationInput.id,
    Component: await getInitialApplication(initialApplicationInput.id),
};
